export default Object.freeze({
	ALLOW_PTOD: 'allowPtod',
	ALLOW_FREE_INSURANCE: 'allowFreeCoverage',
	ALLOW_TABLE_RATE_COVERAGE: 'allowTableRateCoverage',
});